export default __webpack_public_path__ + "static/media/image-ph-health-alarm-w@3x.916f281c.webp";